//@ts-ignore
import { PLACE_TYPE } from "@customTypes/PlaceType";
//@ts-ignore
import { useSearchBeanStore } from "@store/SearchBeanStore";
export function useSearchBeanPlace() {
  var searchBeanStore = useSearchBeanStore();
  var updateSearchBeanBySearchPlace = function updateSearchBeanBySearchPlace(obj) {
    var isValuationActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _a, _b, _c, _d, _e, _f, _g;
    /* We won't update the searchBean if we are in the valuation case */
    if (!obj.place || isValuationActive) return;
    searchBeanStore.updateSearchBean({
      areaOfInterestId: obj.place.areaOfInterestID,
      polygonFromMap: obj.polygon,
      polygonForDB: obj.polygonFromMap || obj.place.polygon,
      areaId: obj.place.areaID,
      placeId: obj.place.placeID,
      placeType: obj.place.placeType,
      localityIdList: (_a = obj.searchBean) === null || _a === void 0 ? void 0 : _a.localityIdList,
      zoneIdList: obj.place.placeType === PLACE_TYPE.DISTRICT ? [] : (_b = obj.searchBean) === null || _b === void 0 ? void 0 : _b.zoneIdList,
      zoneId: obj.place.placeType === PLACE_TYPE.DISTRICT ? null : (_c = obj.searchBean) === null || _c === void 0 ? void 0 : _c.zoneId,
      cityId: obj.place.cityID || searchBeanStore.searchBean.cityID,
      provinceId: obj.place.provinceID,
      regionId: obj.place.regionID,
      cityDisplayName: obj.place.cityName,
      cityURL: obj.place.cityURL,
      zoneURL: (_d = obj.searchBean) === null || _d === void 0 ? void 0 : _d.zoneURL,
      districtURL: (_e = obj.searchBean) === null || _e === void 0 ? void 0 : _e.districtURL,
      districtId: (_f = obj.searchBean) === null || _f === void 0 ? void 0 : _f.districtId,
      districtIdList: (_g = obj.searchBean) === null || _g === void 0 ? void 0 : _g.districtIdList
    });
  };
  var updateSearchBeanByMapPlace = mapPlace => {
    searchBeanStore.updateSearchBean({
      areaOfInterestId: undefined,
      polygonFromMap: mapPlace.polygon,
      polygonForDB: mapPlace.polygonForDB,
      areaId: undefined,
      placeType: undefined,
      placeId: undefined,
      zoneId: undefined,
      zoneIdList: [],
      localityIdList: [],
      cityId: undefined,
      provinceId: undefined,
      regionId: undefined,
      cityDisplayName: undefined,
      cityURL: undefined,
      zoneURL: undefined,
      streetURL: undefined
    });
  };
  var updateCounter = () => {
    if (searchBeanStore.searchBean.contractType && (searchBeanStore.searchBean.placeId || searchBeanStore.searchBean.polygonFromMap)) {
      searchBeanStore.updateSearchBean(searchBeanStore.searchBean);
    }
  };
  return {
    updateSearchBeanBySearchPlace,
    updateSearchBeanByMapPlace,
    updateCounter
  };
}